import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, ExternalLink, Copy } from "lucide-react";
import api, { errMsg } from "@/lib/api";

export default function SelfCheckinLink({ booking, eff, IT }) {
  const [loading, setLoading] = useState(false);
  const [link, setLink] = useState(booking.self_checkin_token
    ? `${window.location.origin}/self-checkin/${booking.self_checkin_token}` : "");
  const submitted = booking.self_checkin_submitted_count || 0;

  const generate = async () => {
    setLoading(true);
    try {
      const r = await api.post(`/bookings/${booking.id}/self-checkin-token`);
      const url = `${window.location.origin}${r.data.path}`;
      setLink(url);
      try { await navigator.clipboard.writeText(url); } catch {}
      toast.success(IT ? "Link Self Check-in copiato negli appunti" : "Self Check-in link copied");
    } catch (e) { toast.error(errMsg(e)); }
    finally { setLoading(false); }
  };

  const copy = async () => {
    try { await navigator.clipboard.writeText(link); toast.success(IT ? "Link copiato" : "Link copied"); }
    catch { toast.error(IT ? "Impossibile copiare" : "Copy failed"); }
  };

  if (!link) {
    return (
      <button
        type="button"
        onClick={generate}
        disabled={loading}
        className="inline-flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-full border border-border hover:border-primary/40 text-muted-foreground hover:text-primary transition-all lift"
        title={IT ? "Genera link Self Check-in per l'ospite" : "Generate Self Check-in link for guest"}
        data-testid={`self-checkin-generate-${booking.id}`}
      >
        <KeyRound className="w-3 h-3"/>
        {loading ? "…" : (IT ? "Link ospite" : "Guest link")}
      </button>
    );
  }
  return (
    <div className="inline-flex items-center gap-1" data-testid={`self-checkin-link-${booking.id}`}>
      <a
        href={link}
        target="_blank" rel="noreferrer"
        className="inline-flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-full border border-sage/40 bg-sage/10 text-sage-foreground hover:border-sage transition-all"
        title={IT ? `Apri link ospite · ${submitted} ospiti inseriti` : `Open guest link · ${submitted} guests submitted`}
        data-testid={`self-checkin-open-${booking.id}`}
      >
        <ExternalLink className="w-3 h-3"/>
        {IT ? "Link" : "Link"}
        {submitted > 0 && <span className="text-[9px] uppercase tracking-widest">· {submitted}</span>}
      </a>
      <button
        type="button"
        onClick={copy}
        className="inline-flex items-center px-1.5 py-1 rounded-full border border-border hover:border-primary/40 text-muted-foreground hover:text-primary"
        title={IT ? "Copia link" : "Copy link"}
        data-testid={`self-checkin-copy-${booking.id}`}
      >
        <Copy className="w-3 h-3"/>
      </button>
    </div>
  );
}
